export default [{
    title: 'Summary',
    icon: require('../../assets/ic_summary_light_gray.png'),
    value: 'summary',
}, {
    title: 'Calendar of Events',
    icon: require('../../assets/ic_calendar_light_gray.png'),
    value: 'event',
}, {
    title: 'Sights / Attractions',
    icon: require('../../assets/ic_sight_light_gray.png'),
    value: 'sight',
}, {
    title: 'Personal Tastes',
    icon: require('../../assets/ic_nearby_light_gray.png'),
    value: 'taste',
}, {
    title: 'Notables',
    icon: require('../../assets/ic_notable_light_gray.png'),
    value: 'notable',
}, {
    title: 'Pictures & Images',
    icon: require('../../assets/ic_nearby_light_gray.png'),
    value: 'picture',
}, {
    title: 'Sponsors',
    icon: require('../../assets/ic_sponsor_light_gray.png'),
    value: 'sponsor',
}, {
    title: 'Town Trivia',
    icon: require('../../assets/ic_trivia_light_gray.png'),
    value: 'trivia',
}, {
    title: 'Exclusive Offer',
    icon: require('../../assets/ic_offer_light_gray.png'),
    value: 'offer',
}, {
    title: 'User Questions',
    icon: require('../../assets/ic_ask_light_gray.png'),
    value: 'ask',
}, {
    title: 'Learn more',
    icon: require('../../assets/ic_learn_light_gray.png'),
    value: 'learn',
}, {
    title: 'Settings',
    icon: require('../../assets/ic_settings_light_gray.png'),
    value: 'settings',
}, {
    title: 'Subscribed Users',
    icon: require('../../assets/ic_user_light_gray.png'),
    value: 'user',
}, {
    title: 'Notifications',
    icon: require('../../assets/ic_subscribe_gray.png'),
    value: 'notification',
}]
